// extracted by mini-css-extract-plugin
module.exports = {"divider":"_3GXa6","bottomGutter":"_1w5se"};